<div class="row" *ngIf="widgetType">
  <div class="col-lg-4">
    <div class="form-group">
      <h3>Show Line</h3>
      <input type="checkbox" [(ngModel)]="widget.showLine"/>
    </div>
  </div>
</div>
